import Vue from "vue";
import VueRouter from "vue-router";
import Home from "../views/index/Home.vue";
import lRouter from "./lRouter";
import tRouter from "./tRouter";

Vue.use(VueRouter);

//避免点击重复路由报错
const originalPush = VueRouter.prototype.push;
VueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
}

const routes = [
  {
    path: "/",
    name: "Home",
    component: Home,
  },
  ...lRouter,
  ...tRouter
];

const router = new VueRouter({
  //mode: "history",
  base: process.env.BASE_URL,
  routes,
});

router.beforeEach((to, from, next) => {
  // ...
  if (to.path == '/') {
    if (JSON.parse(localStorage.getItem("userinfo"))) {
      next();
    } else {
      next('/login');
    }
  } else {
    next();
  }
})
export default router;
